export enum ePages {
  PaymentType = '/',
  EasyPayAccessCode = '/emd-access-code',
  EasyPayPaymentOptions = '/emd-payment-options',
  EasyPayOnlineDeposit = '/emd-online-deposit',
  EasyPayOnlineDepositAccessCode = '/emd-online-deposit-access-code',
  EasyPayOnlineDepositNextSteps = '/emd-online-deposit-next-steps',
  EasyPayWireTransfer = '/emd-wire-transfer',
  EasyPayCheckDeposit = '/emd-check-deposit',
  C2CStatePicker = '/c2c-state-picker',
  C2CPaymentOptions = '/c2c-payment-options',
  C2CWireTransfer = '/c2c-wire-transfer',
  C2CCheckDeposit = '/c2c-check-deposit',
}
